import { OrganisationMember } from '@ih/app/shared/apis/interfaces';

export class SetOrganisations {
  public static readonly type = '[User/Organisations] SetOrganisations';
  constructor(public readonly organisationMembers: OrganisationMember[]) {}
}
